module.exports = __webpack_public_path__ + "img/CM-SS-CA-Acura-Established.28964772.jpeg";